import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import HotelController, { AreaType, RoomType } from '../../../controller/HotelController';
type CanExtendItem = {
  area_id: number;
  checkout_extend: boolean | null;
  short_term_stay_extend: boolean | null;
  accommodation_extend: boolean | null;
};

const HotelNoticeDeviceList = ({ deviceList, setAreaList, refresh, checkoutType }: any) => {
  const [canExtendList, setCanExtendList] = useState<CanExtendItem[]>([]);

  const isSometimes = checkoutType === 1 || checkoutType === 2;
  const isAllday = checkoutType === 0;

  const updateExtendField = (
    areaId: number,
    key: keyof Omit<CanExtendItem, 'area_id'>,
    value: boolean,
  ) => {
    setCanExtendList((prev) =>
      prev.map((item) => (item.area_id === areaId ? { ...item, [key]: value } : item)),
    );
  };

  const toggleRoom = (areaId: number, checked: boolean) => {
    setCanExtendList((prev) => {
      if (checked) {
        return [
          ...prev,
          {
            area_id: areaId,
            checkout_extend: isAllday ? null : false,
            short_term_stay_extend: isAllday ? null : false,
            accommodation_extend: isAllday ? null : false,
          },
        ];
      } else {
        return prev.filter((item) => item.area_id !== areaId);
      }
    });
  };
  const renderExtendCheckbox = (
    areaId: number,
    label: string,
    field: keyof Omit<CanExtendItem, 'area_id'>,
    checked: boolean,
  ) => (
    <label>
      <p>{label}</p>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => updateExtendField(areaId, field, e.target.checked)}
      />
    </label>
  );

  const RoomItem = ({ room }: { room: RoomType }) => {
    const selected = canExtendList.find((item) => item.area_id === room.area_id);

    return (
      <div className="deviceList">
        <label>
          <h4>{room.name}</h4>
          <input
            type="checkbox"
            checked={!!selected}
            onChange={(e) => toggleRoom(room.area_id, e.target.checked)}
          />
        </label>

        {isSometimes && selected && (
          <div className="extendOptions">
            {renderExtendCheckbox(
              room.area_id,
              '퇴실연장',
              'checkout_extend',
              !!selected.checkout_extend,
            )}
            {renderExtendCheckbox(
              room.area_id,
              '대실연장',
              'short_term_stay_extend',
              !!selected.short_term_stay_extend,
            )}
            {renderExtendCheckbox(
              room.area_id,
              '숙박연장',
              'accommodation_extend',
              !!selected.accommodation_extend,
            )}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    setAreaList(canExtendList);
  }, [canExtendList]);

  useEffect(() => {
    setCanExtendList([]);
  }, [refresh, checkoutType]);

  return (
    <Style>
      <div className="totalDeviceListWrap">
        {deviceList?.map((area: AreaType, index: number) => (
          <div key={index} className="deviceBox">
            <div className="deviceHeader">
              <h2>{area.area_name}</h2>
            </div>
            <div className="deviceListWrap">
              {area.room.map((room) => (
                <RoomItem key={room.area_id} room={room} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </Style>
  );
};

export default HotelNoticeDeviceList;

const Style = styled.div`
  h2 {
    font-size: 16px;
    font-weight: 400;
  }
  h4 {
    font-size: 16px;
    font-weight: 500;
    color: #555;
  }
  p {
    margin: 2px 0;
    font-size: 14px;
    font-weight: 500;
  }
  .deviceListWrap {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 11px;
    margin: 10px 0 20px 0;

    .deviceList {
      flex: 1;
      max-width: 110px;
      padding: 7px 13px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }
    label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      cursor: pointer;
    }
  }
  .extendOptions {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px solid #eee;
  }
  input {
    width: 16px;
    height: 16px;
    accent-color: green;
  }

`;
